import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const contactListEndpoint = ApiEndpoints.contact.contactList;

const tableHeader = ["Date", "Name", "phone", "email", "Service", "budget", "location", "city", "message", "Source Url", "IP Address", ];
const tbody = ["createdAt", "name", "phone", "email", "looking_for", "bought", "location", "city", "message", "source_url", "ip_address", ];

export default function LandingPage() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", contactListEndpoint);
            const result = response.contacts;
            setData(result);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);

    const pagename = {
      name: 'Landing Page',
      user: 'Admin',
      innerpage: 'Landing Page'
    }

  const contactUsData = data?.filter((item)=> item.form_type === "landing_form");

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab landpage-table">
        <DataTable
          data={contactUsData}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
